var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#009B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 40.9792C34.9271 40.9792 36.5654 40.3044 37.9149 38.955C39.2643 37.6055 39.9386 35.9677 39.9375 34.0417C39.9375 32.1146 39.2628 30.4763 37.9133 29.1268C36.5639 27.7774 34.9261 27.1031 33 27.1042C31.073 27.1042 29.4347 27.7789 28.0852 29.1284C26.7357 30.4778 26.0615 32.1156 26.0625 34.0417C26.0625 35.9688 26.7373 37.607 28.0868 38.9565C29.4362 40.306 31.074 40.9802 33 40.9792ZM33 37.8958C31.9209 37.8958 31.0087 37.5233 30.2636 36.7781C29.5184 36.033 29.1459 35.1208 29.1459 34.0417C29.1459 32.9625 29.5184 32.0503 30.2636 31.3052C31.0087 30.5601 31.9209 30.1875 33 30.1875C34.0792 30.1875 34.9914 30.5601 35.7365 31.3052C36.4816 32.0503 36.8542 32.9625 36.8542 34.0417C36.8542 35.1208 36.4816 36.033 35.7365 36.7781C34.9914 37.5233 34.0792 37.8958 33 37.8958ZM20.6667 46.375C19.8188 46.375 19.0927 46.0728 18.4883 45.4685C17.884 44.8642 17.5823 44.1386 17.5834 43.2917V24.7917C17.5834 23.9438 17.8855 23.2176 18.4899 22.6133C19.0942 22.009 19.8198 21.7073 20.6667 21.7083H25.523L28.375 18.625H37.625L40.4771 21.7083H45.3334C46.1813 21.7083 46.9074 22.0105 47.5118 22.6148C48.1161 23.2192 48.4177 23.9448 48.4167 24.7917V43.2917C48.4167 44.1396 48.1145 44.8657 47.5102 45.47C46.9059 46.0744 46.1803 46.376 45.3334 46.375H20.6667ZM45.3334 43.2917V24.7917H39.0896L36.2761 21.7083H29.724L26.9105 24.7917H20.6667V43.2917H45.3334Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7b7a78633a990d3e930d20408e85c461.svg";
export { ForwardRef as ReactComponent };